const CheckBox = (props) => {
  const { id, onChange, checked = false } = props
  return (
    <>
      <input type='checkbox'
        checked={ checked }
        onChange={ onChange }
        id={ id }
      />
    </>
  )
}

export default CheckBox